import { render, staticRenderFns } from "./AccountDataMissing.vue?vue&type=template&id=525e1470"
import script from "./AccountDataMissing.vue?vue&type=script&lang=js"
export * from "./AccountDataMissing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports